import React from 'react';
import { motion } from 'framer-motion';
import { Button as ShadcnButton } from './ui/button';

const MotionButton = motion(ShadcnButton);

/**
 * Compatibility wrapper for the new Shadcn Button.
 */
const Button = React.forwardRef(({ variant = 'primary', ...props }, ref) => {
  const variantMap = {
    'primary': 'primary',
    'secondary': 'secondary',
    'danger': 'destructive',
    'ghost': 'ghost'
  };

  return (
    <MotionButton 
      ref={ref}
      whileTap={{ scale: 0.96 }}
      variant={variantMap[variant] || variant} 
      {...props} 
    />
  );
});

Button.displayName = 'Button';

export default Button;
